<style scoped>

</style>

<template>
  <mu-paper :z-depth="1">
    <MediaContentPanel
      :channel="channel"
      :media="media"
      :currentTime="currentTime"
      @onUpdateTime="onUpdateTime"
      :flagPauseSwitch="flagPauseSwitch"
      :timestamp="timestamp"
      :timestampTrigger="timestampTrigger"
      :overlays="overlays"
      :isAdmin="isAdmin"
      :playerState="playerState"
      @onPlayerState="onPlayerState"
      :startFrom="startFrom"
      />
      <media-bar
        :mediaId="mediaId"
        :currentTime="currentTime"
        :type="media.type"
        :media="media"
        :isAdmin="isAdmin"
        @onPause="onPause"
        @onPlay="onPlay"
        @onClickTag="$emit('onClickTag', $event)"
        :tag="tag" />
  </mu-paper>

</template>

<script>

// Components
import MediaBar from '@/components/Media/MediaBar.vue'
import MediaContentPanel from '@/components/Media/MediaContentPanel.vue'

export default {
  name: 'MediaPanel',
  components: {
    MediaBar,
    MediaContentPanel,
  },
  props: {
    channel: {
      type: Object,
      required: true
    },
    media: {
      type: Object,
      required: true
    },
    overlays: {
      type: Array,
      required: true
    },
    mediaId: {
      type: String
    },
    currentTime: {
      type: Number,
      required: true
    },
    timestamp: {
      type: Number,
      required: false
    },
    isAdmin: {
      type: Boolean
    },
    flagPauseSwitch: {
      type: Boolean,
      required: false
    },
    timestampTrigger: {
      type: Boolean,
      required: false
    },
    tag: {
      type: Object,
      default() {
        return {
          action: '',
          tagId: ''
        }
      }
    },
    playerState: {
      type: Object,
      default() {
        return {}
      }
    },
    startFrom: {
      type: String
    }
  },
  data() {
    return {
      
    }
  },
  computed: {
    // Store
    triggerRefresh() {
      return this.$store.getters.triggerRefresh;
    },
  },
  watch: {
    triggerRefresh() {

    },
  },
  created() {

  },
  methods: {
    onPlay() {
      this.$emit('onPlay');
    },
    onPause() {
      this.$emit('onPause');
    },
    onUpdateTime(payload) {
      this.$emit('onUpdateTime', payload);
    },
    onPlayerState(payload) {
      this.$emit('onPlayerState', payload);
    },
  },
}
</script>
